/**
 * Constants for notification configuration
 */

export const STORE_NAME_DEV_TOOLS = 'notification-store';
